document.addEventListener('DOMContentLoaded', () => {
    const product_cards = document.querySelectorAll('.product_card');
    product_cards.forEach(card =>{
        const handle = card.dataset.handle;
        const add_btns = card.querySelectorAll('.cart-add');
        const openOption = card.querySelector('[data-openList]');
        const idInput = card.querySelector('[name="id"]');
        const list = card.querySelector('[data-list]');
        const initial = card.querySelector('[data-initial]');
        let product;

        axios.get(`/products/${handle}.js`).then((results) => {
            product = results.data
        });
        add_btns.forEach(add_btn =>{

        
            add_btn.addEventListener('click', (e)=>{
                e.preventDefault();
                e.stopPropagation();
                const id = parseInt(idInput.value)
                let formData = {
                    'items': [{
                        'id': id,
                        'quantity': 1
                    }]
                };
                fetch(window.Shopify.routes.root + 'cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(formData)
                })
                .then(response => {
                    let variant = product.variants.filter(val => val.id === id );
                    window.cartVM.openPopup(product, variant[0]);
                    return response.json();
                })
                .catch((error) => {
                    console.error('Error:', error);
                });
            })
        })
        
        
        if (!list) return
        openOption?openOption.addEventListener('click', (e)=>{e.preventDefault(); e.stopImmediatePropagation();openList()}):false
        function openList(){
            document.querySelectorAll('[data-list]').forEach(el => el.classList.remove('w--open'))
            list.classList.add('w--open')
        }

        document.addEventListener("click", (event) =>{
            hideFilterOnOuterClick(event, list, openOption)
        });
        

        const items = list.querySelectorAll('[data-drop-item]');
        items.forEach(item =>{
            item.addEventListener('click', () =>{
                list.classList.remove('w--open');
                idInput.value = item.dataset.dropItem;
                initial.innerHTML = item.querySelector('label span').innerHTML;
            })
        })
        
    })
    function hideFilterOnOuterClick(event, list, openOption) {
        if (list.contains(event.target)) return;
        if (openOption.contains(event.target)) return;
        list.classList.remove('w--open')
    }
   
}) 
